<script lang="ts" setup>
import Button from 'primevue/button';
import type {
  ButtonSeverity,
  ButtonSize,
  ButtonVariant,
} from '~/types/components/base/Button';

/**
 * https://primevue.org/button/#api.button.props
 */
const {
  label = undefined,
  icon = undefined,
  variant = undefined,
  as = undefined,
  href = undefined,
  severity = undefined,
  size = undefined,

  disabled = false,
  loading = false,
  raised = false,
  rounded = false,
  text = false,
  outlined = false,
} = defineProps<{
  label?: string;
  icon?: string;
  as?: string | Component;
  href?: string;
  variant?: ButtonVariant;
  severity?: ButtonSeverity;
  size?: ButtonSize;

  disabled?: boolean;
  loading?: boolean;
  raised?: boolean;
  rounded?: boolean;
  text?: boolean;
  outlined?: boolean;
}>();
</script>

<template>
  <Button
    :label="label"
    :icon="icon"
    :as="as"
    :href="href"
    :variant="variant"
    :severity="severity"
    :size="size"
    :disabled="disabled"
    :loading="loading"
    :raised="raised"
    :rounded="rounded"
    :text="text"
    :outlined="outlined"
    class="app-button"
  >
    <slot />
  </Button>
</template>

<style lang="scss" scoped>
.app-button {
  // Secondary buttons follow the Figma design and must not be bold.
  &:not(.p-button-secondary) * {
    font-weight: 600;
  }
}
</style>
